import React, { useEffect, useRef } from 'react';

import { ReactComponent as NodeActionControlBoxArrowIcon } from 'assets/images/node-action-control-box-arrow-icon.svg';

import './index.scss';

function ExpandableNodeActionMenuItem(props) {

  const Icon = props.Icon;
  const name = props.name;

  const nodeMenuItemDynamicContentReference = useRef(null);

  useEffect(function onNodeMenuDynamicContentExpand() {

    const element = nodeMenuItemDynamicContentReference.current;

    if (element === null) {
      return;
    }

    if (props.scrollToView === false) {
      return;
    }

    const scrollTarget = element.querySelector(props.scrollTarget) || element;

    scrollTarget.scrollIntoView({
      behavior: 'smooth',
      block: 'end'
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.activeMenuItemName]);

  function handleMenuItemClick() {

    if (typeof props.onClick === 'function') {
      return props.onClick();
    }

    props.toggleActiveMenuItem(props.name);

  }

  function renderDynamicContent() {

    if (props.activeMenuItemName !== props.name) {
      return;
    }

    const nodePropertiesMenuItemDynamicContentAttributes = {
      className: 'node-properties-menu-item-dynamic-content',
      ref: nodeMenuItemDynamicContentReference
    };

    return <div {...nodePropertiesMenuItemDynamicContentAttributes}>

      {props.contentRenderer()}

    </div>;

  }

  function renderStaticContent() {

    const staticContentContainerAttributes = {
      className: 'node-action-menu-item-static-content',
      onClick() {
        handleMenuItemClick();
      }
    };

    const contentToggleButtonAttributes = {
      type: 'button',
      onClick(event) {
        event.stopPropagation();
        handleMenuItemClick();
        return false;
      }
    };

    return <div {...staticContentContainerAttributes}>

      <div className="node-action-menu-item-icon">
        <Icon />
      </div>

      <span>{name}</span>

      <button {...contentToggleButtonAttributes}><NodeActionControlBoxArrowIcon /></button>

    </div>;

  }

  function renderMain() {

    const mainAttributes = {
      className: 'expandable-node-action-menu-item-main ' + (props.className || '')
    };

    return <div {...mainAttributes}>

      {renderStaticContent()}

      {renderDynamicContent()}

    </div>;

  }

  return renderMain();

}

export default ExpandableNodeActionMenuItem;